const loadSearchIconDynamically = ({
  labEdit = '',
  labSave = '',
  iconEditNoAlarm,
  iconSave,
  iconEditAlarm,
  hasAlerts = false,
  searchIsSaved = false,
}) => {
  let labelBtn = searchIsSaved ? labEdit : labSave;
  let iconName = searchIsSaved ? iconEditNoAlarm : iconSave;
  if (hasAlerts) {
    labelBtn = labEdit;
    iconName = iconEditAlarm;
  }
  return { labelBtn, iconName };
};

export default loadSearchIconDynamically;
